module.exports = __webpack_public_path__ + "img/humedad_blue.cbc418db.svg";